export default {"src":"/_next/static/media/arcadis.6b8c80cd.svg","height":21,"width":137,"blurWidth":0,"blurHeight":0};